import { render } from "./CasesLebonan.vue?vue&type=template&id=725d4e18&scoped=true"
import script from "./CasesLebonan.vue?vue&type=script&lang=js"
export * from "./CasesLebonan.vue?vue&type=script&lang=js"

import "./CasesLebonan.vue?vue&type=style&index=0&id=725d4e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725d4e18"]])

export default __exports__